(function () {
  const SELECTOR_OPEN = '[data-size-guide-open]';
  const SELECTOR_OVERLAY = '[data-size-guide-overlay]';
  const SELECTOR_CLOSE = '[data-size-guide-close]';

  let lastFocused = null;

  function openModal(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;

    modal.hidden = false;
    document.documentElement.classList.add('no-scroll');

    // Focus modal for accessibility
    modal.focus();

    // Close on ESC
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeModal(modal);
    };
    modal._onKeyDown = onKeyDown;
    document.addEventListener('keydown', onKeyDown);
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('no-scroll');

    if (modal._onKeyDown) {
      document.removeEventListener('keydown', modal._onKeyDown);
      modal._onKeyDown = null;
    }

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest(SELECTOR_OPEN);
    if (openBtn) {
      const id = openBtn.getAttribute('data-size-guide-open');
      openModal(document.getElementById(id));
      return;
    }

    const closeBtn = e.target.closest(SELECTOR_CLOSE);
    if (closeBtn) {
      const modal = closeBtn.closest(SELECTOR_OVERLAY);
      closeModal(modal);
      return;
    }

    // Click outside modal closes
    const overlay = e.target.matches(SELECTOR_OVERLAY) ? e.target : null;
    if (overlay) closeModal(overlay);
  });
})();
